<!-- Loader till we get response from api -->
<div *ngIf="!config?.paymentDetails">
  <app-placeholder-loader *ngFor="let i of [1,2,3,4,6,7]" type="text"></app-placeholder-loader>
</div>

<div class="payment-otd-form {{config?.theme}}" [hidden]="oneTapOtpPopup || vars.upiTimer" *ngIf="config?.paymentDetails" [ngClass]="{'is-active': paymentV2.selectedButtonId.getValue() === config?.buttonId}">
  <div *ngIf="config?.donatingAs" class="user-info">
    <div *ngIf="!config?.theme?.match('v1')" class="pre-title">Donating as</div>
    <div class="name-edit">
      <span class="name" *ngIf="config?.theme?.match('v1')">Hi {{config?.user?.full_name}},</span>
      <span class="name" *ngIf="!config?.theme?.match('v1')">{{config?.user?.full_name}}</span>
      <span *ngIf="!paymentV2.isOrderLoading" class="edit" (click)="openPaymentPopup('form', paymentModule, 'editDetails')" mat-ripple>
        <span class="material-icons">edit</span>
      </span>
    </div>
    <div *ngIf="config?.theme?.match('v1')" class="pre-title"> keep doing good, repeat your last donation with us.</div>
  </div>
  
  <app-tipcard-info *ngIf="config?.showTipCard"></app-tipcard-info>

  <div *ngIf="config?.showTip && !config?.frtip" class="payment-sip-form-slabs">
    <app-payment-sip-slabs [config]="config" (setCurrency)="getContributeDetails($event)" (amountEmit)="setAmount($event, 'tip')"></app-payment-sip-slabs>
  </div>

  <div *ngIf="config?.showSlabs" class="payment-sip-form-slabs">
    <app-payment-sip-slabs [config]="config" (setCurrency)="getContributeDetails($event)" (amountEmit)="setAmount($event, '')"></app-payment-sip-slabs>
  </div>
  <div *ngIf="config?.theme?.match('v2') || config?.theme?.match('v3')" class="recocard-title" [ngClass]="{'lpnull': !lastPaymentMode}">Pay <app-currency-icon *ngIf="landingCurrency" [currency]="config?.order?.iso_currency"></app-currency-icon> {{config?.order?.donated_amount_local}} {{lastPaymentMode ? 'via':''}}</div>
  <div class="payment-btn-wrapper">
    <div class="last-payment-op" *ngIf="lastPaymentMode && !config?.showTipCard" [ngClass]="{'pos1': config?.currency !== 'INR' && config?.theme?.match('v4')}">
      <div  *ngIf="!config?.theme" class="op-text">Pay via</div>
      <div  *ngIf="config?.theme?.match('v1')" class="op-text">Paying via</div>
      <span [ngClass]="'payment-icons-v1 OP_' + lastPaymentMode?.payment_mode+ ' ' +lastPaymentMode?.payment_mode_value?.toUpperCase()"></span>
      <div class="op-text">
        <span class="op-value" *ngIf="lastPaymentMode?.payment_mode==='CARD'">***{{lastPaymentMode?.checksum?.last4}}</span>
        <span class="op-value" *ngIf="lastPaymentMode?.payment_mode==='NB'">{{lastPaymentMode?.checksum?.name?.toLowerCase()}}</span>
        <span class="op-value" *ngIf="lastPaymentMode?.payment_mode==='WALLET'">{{lastPaymentMode?.payment_mode_value?.toLowerCase()}}</span>
        <span class="op-value" *ngIf="lastPaymentMode?.payment_mode==='UPI' && lastPaymentMode?.payment_mode_value==='VPA'">{{lastPaymentMode?.checksum}}</span>
        <span class="op-value" *ngIf="lastPaymentMode?.payment_mode==='UPI' && lastPaymentMode?.payment_mode_value!=='VPA'">{{lastPaymentMode?.payment_mode_value?.toLowerCase()}}</span>
      </div>
      <button *ngIf="!config?.theme?.match('v1')" class="change-btn" (click)="createCart('changePay', paymentModule)" mat-button>change</button>
    </div>
    <div class="payment-sip-form-donate-btn" *ngIf="!config?.frtip">
      <app-payment-sip-button [config]="config" (btnClick)="createCart(lastPaymentMode ? 'lastPay' : 'changePay', paymentModule)"></app-payment-sip-button>
    </div>
    <div class="donate-btn" *ngIf="config?.frtip">
      <button (click)="enableTip()" [innerHTML]="config.donateBtnLabel"></button>
    </div>
    <!-- Captcha Form -->
    <form class="captcha-form" *ngIf="config?.currency!=='INR'" [formGroup]="captchaForm">
      <div class="note">
        This site is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
        <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
      </div>
      <app-captcha-input [control]="captchaForm.get('captcha')" type="sheet" size="invisible" [execute]="true" #captchaRef></app-captcha-input>
    </form>
  </div>

</div>

<!-- One tap otp confrimation -->
<div [hidden]="!oneTapOtpPopup">
  <app-module-loader moduleId="otp-confirmation" selector="app-otp-confirmation"
                    [load]="oneTapOtpPopup"
                    [inputs]="{type: 'onpage'}"
                    [outputs]="{ verified: otpVerified }">
  </app-module-loader>
</div>

<!-- time screen for upi payment -->
<div class="upi-timer" *ngIf="vars.upiTimer">
  <app-payment-sip-upi-timer></app-payment-sip-upi-timer>
</div>


<!-- Payment Module -->
<ng-template #paymentModule>
  <app-main-payment [fundraiser]="config?.fundraiser" [sipCause]="config?.sipCause"
                    [showBeneficiary]="config?.showBeneficiary" type="full" [internal]="true" [origin]="config?.origin"
                    [contributeDetails]="config?.paymentDetails" [screenName]="screenName" [tiptyp]="config?.tip_only" [updateId]="params?.update_id">
  </app-main-payment>
</ng-template>